import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7dd508a4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7dd508a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd508a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd508a4')) {
      api.createRecord('7dd508a4', component.options)
    } else {
      api.reload('7dd508a4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7dd508a4&scoped=true", function () {
      api.rerender('7dd508a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operatingPlatform/storagePartsScanning/index.vue"
export default component.exports